import { docodeHexResponse } from "../../_common/common.utils";
import DiallerPushLogTypes from "./diallerPushLog.types";
const INITIAL_STATE: any = {
  diallerPushLogFetchResponseArr: [],
  diallerrPushLogFetchResponse: null,
};
const diallerPushLogReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case DiallerPushLogTypes.DIALLER_PUSH_LOG_FETCH_SUCCESS:
      return {
        ...state,
        diallerrPushLogFetchResponse: action.payload,
        diallerPushLogFetchResponseArr: docodeHexResponse(
          action.payload,
          "DiallerPushLogKey",
        ),
      };

    case DiallerPushLogTypes.DIALLER_PUSH_LOG_FETCH_FAILURE:
      return {
        ...state,
        diallerrPushLogFetchResponse: action.payload,
        diallerPushLogFetchResponseArr: [],
      };

    case DiallerPushLogTypes.DIALLER_PUSH_LOG_FETCH_RESPONSE_CHANGED:
      return { ...state, diallerrPushLogFetchResponse: null };

    default:
      return state;
  }
};
export default diallerPushLogReducer;
